import "./App.css";
import Header from "./components/Header";
import Swap from "./components/Swap";
import TokenBalances from "./components/TokenBalances";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useAccount, useWalletClient } from "wagmi";
import { useEffect, useState } from "react";
import { ethers } from "ethers";
import { NetworkProvider } from './components/NetworkContext';

const clientToProviderSigner = async (client) => {
  const { account, chain, transport } = client;
  const provider = new ethers.providers.Web3Provider(transport);
  const signer = provider.getSigner(account?.address);
  return { provider, signer };
};

function App() {
  const { address, isConnected } = useAccount();
  const { data: walletClient } = useWalletClient();
  const [provider, setProvider] = useState(null);
  const [signer, setSigner] = useState(null);

  useEffect(() => {
    const connectWallet = async () => {
      if (!walletClient) return;
      const { provider, signer } = await clientToProviderSigner(walletClient);
      setProvider(provider);
      setSigner(signer);
    };

    if (isConnected && walletClient) {
      connectWallet();
    }
  }, [isConnected, walletClient]);

  return (
    <NetworkProvider provider={provider}>
      <div className="App">
        <Header isConnected={isConnected} address={address} provider={provider} />
        <div className="mainWindow">
          <Routes>
            <Route path="/" element={<Swap isConnected={isConnected} address={address} provider={provider} signer={signer} />} />
            <Route path="/swap" element={<Swap isConnected={isConnected} address={address} provider={provider} signer={signer} />} />
            <Route path="/balances" element={<TokenBalances isConnected={isConnected} address={address} />} />
          </Routes>
        </div>
      </div>
    </NetworkProvider>
  );
}

export default App;